<template>
  <v-card class="nohandcursor" v-if="doc" :hover="true">
    <v-card-title class="py-2">
      <v-spacer></v-spacer>
      <v-chip
          v-for="category in categories"
          :id="`category-${categoryLabel(category).label}`"
          :key="`category-${categoryLabel(category).label}`"
          :color="categoryLabel(category).color"
          text-color="white"
          class="mx-1"
      >
        {{ categoryLabel(category).label }} ({{category.score | numeral("0.[0]%") }})
      </v-chip>
<!--      <v-chip :id="`category-${index}`" color="grey lighten-2" text-color="grey darken-3">-->
<!--        {{ segment.score | numeral('0.[0]%') }}-->
<!--      </v-chip>-->
      <v-spacer></v-spacer>
      <v-menu
          offset-y
          id="menu-doc"
          v-if="canExportDocuments || canDeleteDocuments || canSeeTest"
      >
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="downloadDocumentAsJson()" id="btn_doc_export">
            <v-list-item-title>{{ $t("document.label.exportDoc") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>
    <AltTexts :doc="doc"></AltTexts>
    <v-card-text class="text--primary subtitle-1">
      <div
          :class="{
            rtl: isRightToLeftText(doc.text),
            [`font-${projectLanguage}`]: true,
          }"
          style="white-space: pre-wrap; letter-spacing: 0em !important"
          kt:docid="nodocid"
          v-bind:kt:start="0"
          v-bind:kt:end="doc.text.length"
          @mouseenter="enterAnnotationArea()"
          @mouseleave="leaveAnnotationArea()"
          @mousedown="startTextSelection()"
          @mouseup="endTextSelection()"
          @dblclick="handleSelectedText()"
          :id="containerId"
          v-text="doc.text"
      ></div>
      <!-- v-html="doc.text" -->
      <!-- {{ doc.text }} -->
    </v-card-text>
    <!-- Using a renderless component because it is impossible to track changes made in the annotation array by the vuex store -->
    <!-- FIXME?: replace the v-bind:annot with a :annot -->
    <RenderlessAnnotation
        v-for="annot in doc.annotations"
        v-bind:annot="annot"
        :key="annot.identifier"
        :containerId="containerId"
        :containerMounted="mounted"
    ></RenderlessAnnotation>
  </v-card>
</template>

<script>
import AltTexts from "../document/AltTexts";
import RenderlessAnnotation from "../RenderlessAnnotation";
import annotationContainerMixin from "../../mixins/annotationContainerMixin";
import languageMixin from "../../mixins/languageMixin";
import {mapState, mapGetters, mapMutations, mapActions, } from "vuex";
import MD5 from "crypto-js/md5";

export default {
  props: ["doc"],
  mixins: [annotationContainerMixin, languageMixin],
  components: {
    RenderlessAnnotation,
    AltTexts,
  },
  data() {
    return {
      // required by the RenderlessAnnotation
      mounted: false,
      // required by the annotationContainer mixin
      containerId: "testtext",
    };
  },
  beforeMount() {
    this.setDocumentLanguage(this.doc?.metadata?.language)
  },
  mounted() {
    console.debug("TestResultCard mounted");
    this.mounted = true;
  },
  beforeDestroy() {
    console.debug("TestResultCard destroyed");
    this.mounted = false;
  },
  computed: {
    ...mapState(["annotDetailsDrawer"]),
    ...mapState(["project"]),
    ...mapState("settings", ["labelsByName"]),
    ...mapGetters(["projectLanguage"]),
    ...mapGetters("annotationDetails", ["entityFishing"]),
    ...mapGetters("auth", ["canExportDocuments"]),
    categories() {
      if (this.doc && this.doc.categories) {
        const result = this.doc.categories;
        return result;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapMutations(["setAnnotDetailsDrawer"]),
    ...mapMutations("annotationDetails", {
      setAnnotationForDetails: "setAnnotation",
    }),
    ...mapActions("annotationDetails", ["getWikiInfo"]),
    isRightToLeftText(text) {
      return this.containsCharactersFromRightToLeftLanguage(text);
    },
    categoryLabel(category) {
      const labelStr = category.labelName
          ? category.labelName
          : category.label;
      let label = this.labelsByName[labelStr];
      if (!label)
        label = {name: category.labelName, label: `#${category.labelName}`, color: "#BBBBBB"}
      return label;
    },
    // required by the mixin
    // eslint-disable-next-line
    maybeCreateAnnotation(annotation) {
      console.log("can't create annotations in test view");
    },
    // required by the mixin
    // eslint-disable-next-line
    maybeDeleteAnnotation(annotation) {
      console.log("can't delete annotations in test view");
    },
    maybeSelectAnnotation(annotation) {
      if (annotation.terms || annotation.properties) {
        if (!this.annotDetailsDrawer) {
          this.setAnnotDetailsDrawer(true);
        }
        this.setAnnotationForDetails(annotation);
      }
    },
    async downloadDocumentAsJson() {
      const contentType = "application/json";
      this.doc.identifier = MD5(this.doc.text).toString();
      this.doc.title = "unknown test document";
      const dData = JSON.stringify(this.doc, null, 2);
      const blob = new Blob([dData], {type: contentType});
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${this.project.name}-document-test.json`);
      document.body.appendChild(link);
      link.click();
    },
  }
};
</script>

<style>
.nohandcursor {
  cursor: default !important;
}
</style>